/**
 * APP_VERSION — bumped manually each iteration. Shown next to the
 * brand name in the topbar so you can tell at a glance which version
 * is running on production vs. preview.
 *
 * Convention: `iter{NNN}{letter}` matches the iteration tag in PRD.md.
 */
export const APP_VERSION = "iter150T";
